import styled from 'styled-components'

export const ErrorNetWork = styled.div`
  position: fixed;
  left: 5rem;
  z-index: 9999;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background-color: #ffeef8;
  border-radius: 16px;
  cursor: pointer;
`